import api from './index'
import { stringify } from 'qs'
import { axios } from '@/utils/request'

export function login (params) {
  return axios({
    url: api.login,
    method: 'post',
    data: params
  })
}

export function getProject (params) {
  return axios(`${api.getProject}?${stringify(params)}`)
}

export function listProjectCrane (projectId) {
  return axios(`${api.projectCrane}/${projectId}`)
}

export function getSingleProject (id) {
  return axios(`${api.getSingleProject}/${id}`)
}

export function getConfig (id) {
  return axios(`${api.getConfig}/${id}`)
}

export function getDayStaticData (params) {
  return axios(`${api.getDayStaticData}/${params.nodeId}?${stringify(params)}`)
}

export function getRealData (params) {
  return axios(`${api.getRealData}/${params.nodeId}?${stringify(params)}`)
}

export function getRunData (id) {
  return axios(`${api.getRunData}/${id}`)
}

// 获取报警详情
export function getAlarmDetail (params) {
  return axios(`/api/ListTickets/${params.nodeId}/ticketType/${params.ticketType}/sub/${params.subTicketType}?${stringify(params)}`)
}

export function getBoxData (ids) {
  return axios({
    url: api.getBoxData,
    method: 'post',
    data: ids
  })
}

export function getBoxInfo (id) {
  return axios(`${api.getBoxInfo}/${id}`)
}

export function getBoxMetric (id) {
  return axios(`${api.getBoxMetric}/${id}`)
}

export function refreshToken () {
  return axios({
    url: api.refreshToken,
    method: 'post'
  })
}

export function projectPicture (id) {
  return axios({
    url: `${api.projectPicture}/${id}`
  })
}

export function getYSToken () {
  return axios(`${api.getYSToken}`)
}



// WEBPACK FOOTER //
// ./src/api/metric.js